"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cfeConverter = void 0;
const cfeConverter = {
    toFirestore(cfe) {
        return cfe;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            generador: data.generador,
            generadorId: data.generadorId,
            xml: data.xml,
            numero: data.numero,
            tcfe: data.tcfe,
            serie: data.serie,
            idCAE: data.idCAE,
            timestampFirma: data.timestampFirma,
            fechaFirma: data.fechaFirma,
            anulado: data.anulado,
            estadoDGI: data.estadoDGI,
            receptorNombre: data.receptorNombre,
            receptorId: data.receptorId,
            receptorPDFpendienteEnvio: data.receptorPDFpendienteEnvio,
            receptorXMLpendienteEnvio: data.receptorXMLpendienteEnvio,
            logEnvio: data.logEnvio,
            adenda: data.adenda,
            moneda: data.moneda,
            total: data.total,
            esRecibo: data.esRecibo,
            motivoRechazoDGI: data.motivoRechazoDGI,
            motivoRechadoReceptor: data.motivoRechadoReceptor,
            rechazoNotificadoMail: data.rechazoNotificadoMail,
            estadoReceptor: data.estadoReceptor,
            codigoAbitab: data.codigoAbitab || null
        };
    }
};
exports.cfeConverter = cfeConverter;
